// extracted by css-extract-rspack-plugin
export default {"root":"src-features-Integrations-components-IntegrationStatusBadge-assets-IntegrationStatusBadge-module__root-nb5L8b","loadingContent":"src-features-Integrations-components-IntegrationStatusBadge-assets-IntegrationStatusBadge-module__loadingContent-qOGDuR"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"root\":\"src-features-Integrations-components-IntegrationStatusBadge-assets-IntegrationStatusBadge-module__root-nb5L8b\",\"loadingContent\":\"src-features-Integrations-components-IntegrationStatusBadge-assets-IntegrationStatusBadge-module__loadingContent-qOGDuR\"}";
        // 1791855167457
        var cssReload = require("../../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  